import SpriteSymbol from "../../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play-gloden",
  "use": "icon-play-gloden-usage",
  "viewBox": "0 0 11 14",
  "content": "<symbol viewBox=\"0 0 11 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play-gloden\">\r\n<path d=\"M9.67425 6.15634C10.2917 6.54929 10.2917 7.45071 9.67425 7.84366L1.53688 13.022C0.871153 13.4456 4.095e-08 12.9674 7.22435e-08 12.1783L4.82966e-07 1.82167C5.14259e-07 1.03258 0.871151 0.554368 1.53688 0.978012L9.67425 6.15634Z\" fill=\"#C39135\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol